import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48db7432"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "futher" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "landing__title--tertiary" }, "Компании для трудоутройства", -1))
const _hoisted_3 = {
  class: "futher__grid",
  style: {"margin-bottom":"80px"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "landing__title--tertiary" }, "Программы международного взаимодействия", -1))
const _hoisted_6 = { class: "futher__grid" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "futher__grid-item",
          key: company
        }, [
          _createElementVNode("img", {
            class: "futher__logo",
            src: require(`@/assets/companies-icons/${company}`)
          }, null, 8, _hoisted_4)
        ]))
      }), 128))
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.universites, (uni) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "futher__grid-item",
          key: uni
        }, [
          _createElementVNode("img", {
            class: "futher__logo",
            src: require(`@/assets/international-unis-icons/${uni}`)
          }, null, 8, _hoisted_7)
        ]))
      }), 128))
    ])
  ]))
}